/* eslint-disable react/prop-types */
import * as React from 'react';

import { IAmpProps } from '../../../../typings/amp';

// FIXME: If ANY of this PROPS is MANDATORY then TS throws
// "semantic error TS2739 is missing the following properties from type 'IAmpImgProps'" or
// "ts(2741) Property 'src' is missing in type '{ children: (string | Element | null)[]; className: any; }' but required in type 'IAmpImgProps'"
// in every CHILDREN of a REACT CUSTOM TAG!
// But we should ALWAYS use SRC and CLASSNAME as MANDATORY
export interface IAmpImgProps
  extends IAmpProps,
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  src?: string;
  className?: string;
}

const AmpImg: React.FC<IAmpImgProps> = ({
  src = '',
  className = '',
  width = '100',
  height = '100',
  layout = 'fixed',
}) => {
  return <amp-img src={src} className={className} layout={layout} width={width} height={height} />;
};

export default AmpImg;
